import { createAuthedHttpClient } from '@driftt/web-auth'
import config from 'config'

export const CustomerAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CUSTOMER_API
  }
})

export const FileAPI = createAuthedHttpClient({
    baseConfig: {
      baseURL: config.FILE_API,
      raw: true
    }
})

export const KnowledgebaseAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.KNOWLEDGEBASE_API,
  }
})

export const ReportAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.REPORT_API,
  }
})